import { useLayoutEffect, useRef, useState } from "react";

const MINIMUM_HEIGHT = 480;

/**
 * Sizes an element to fill the window below wherever it starts, so the list and reading pane
 * can scroll on their own like a mail client. The legacy dashboard header above the tab
 * changes height, so the offset is measured rather than assumed.
 */
export const useFillViewportHeight = <T extends HTMLElement>(bottomGap = 16) => {
  const ref = useRef<T>(null);
  const [height, setHeight] = useState(MINIMUM_HEIGHT);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;

    const measure = () => {
      const top = element.getBoundingClientRect().top + window.scrollY;
      setHeight(Math.max(MINIMUM_HEIGHT, window.innerHeight - top - bottomGap));
    };

    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, [bottomGap]);

  return { ref, height };
};
